import CloseIcon from 'images/svg/close-white.svg';
import classNames from './toast-service.module.css';

const setStyles = (el, styles) => {
  Object.keys(styles).forEach((key) => {
    el.style[key] = styles[key];
  });
};

const setAttrs = (el, attrs) => {
  Object.keys(attrs).forEach((key) => {
    el.setAttribute(key, attrs[key]);
  });
};

const getAttr = (el, attr) => el.getAttribute(attr);

const privateKeys = {
  defaultOptions: Symbol('defaultOptions'),
  render: Symbol('render'),
  show: Symbol('show'),
  hide: Symbol('hide'),
  removeDOM: Symbol('removeDOM'),
};

const customToast = {
  [privateKeys.defaultOptions]: {
    container: 'body',
    class: classNames['custom-toast'],
    position: 'bottom|right',
    margin: 15,
    delay: 0,
    duration: 30000,
    style: {},
  },

  setOptions(options = {}) {
    return {
      ...customToast,
      [privateKeys.defaultOptions]: {
        ...this[privateKeys.defaultOptions],
        ...options,
      },
    };
  },

  [privateKeys.render](state, message, options = {}) {
    const mergedOptions = {
      ...this[privateKeys.defaultOptions],
      ...options,
    };

    const {class: className, position, delay, duration, style} = mergedOptions;

    const newToast = document.createElement('div');

    // logging via attrs
    newToast.className = className + ' d-flex align-items-center';
    newToast.innerHTML = `<div class=" text-wrap mr-2 font-weight-bold">${message} </div><button type="button" class="customToast--close"></button>`;

    const closeButton = document.createElement('button');
    closeButton.classList.add('customToast--close');
    closeButton.innerHTML = `<img src=${CloseIcon} />`;

    setAttrs(newToast, {
      'data-position': position,
      'data-state': state,
    });

    setStyles(newToast, style);

    // use .setTimeout() instead of $.queue()
    let time = 0;
    setTimeout(() => {
      this[privateKeys.show](newToast, mergedOptions);
    }, (time += delay || 0));
    const timeoutId = !mergedOptions.manualClose
      ? setTimeout(() => {
          this[privateKeys.hide](newToast);
        }, (time += duration))
      : null;
    closeButton.addEventListener('click', () => {
      clearTimeout(timeoutId);
      this[privateKeys.hide](newToast);
    });
    newToast.appendChild(closeButton);
    // support method chaining
    // return this;
    return {toast: newToast, self: this};
  },

  [privateKeys.show](el, {container, class: className, margin}) {
    const hasPos = (v, pos) => getAttr(v, 'data-position').indexOf(pos) > -1;

    const root = document.querySelector(container);
    root.insertBefore(el, root.firstChild);

    // set initial position
    setStyles(el, {
      position: container === 'body' ? 'fixed' : 'absolute',
      [hasPos(el, 'top') ? 'top' : 'bottom']: '-100px',
      [hasPos(el, 'left') && 'left']: '1.5rem',
      [hasPos(el, 'center') && 'left']: `${
        root.clientWidth / 2 - el.clientWidth / 2
      }px`,
      [hasPos(el, 'right') && 'right']: '1.5rem',
    });

    setStyles(el, {
      transform: 'scale(1)',
      opacity: 1,
    });

    // push effect
    let pushStack = margin;

    Array.from(
      document.querySelectorAll(
        `.${className}[data-position="${getAttr(el, 'data-position')}"]`,
      ),
    )
      .filter((toast) => toast.parentElement === el.parentElement) // matching container
      .forEach((toast) => {
        setStyles(toast, {
          [hasPos(toast, 'top') ? 'top' : 'bottom']: `${pushStack}px`,
        });

        pushStack += toast.offsetHeight + margin;
      });
  },

  [privateKeys.hide](el) {
    if (!el) return console.error('no el', el);
    const hasPos = (v, pos) => getAttr(v, 'data-position').indexOf(pos) > -1;
    const {left, width} = el.getBoundingClientRect();

    setStyles(el, {
      [hasPos(el, 'left') && 'left']: `${width}px`,
      [hasPos(el, 'center') && 'left']: `${left + width}px`,
      [hasPos(el, 'right') && 'right']: `-${width}px`,
      opacity: 0,
    });

    const whenTransitionEnd = () => {
      this[privateKeys.removeDOM](el);
      el.removeEventListener('transitionend', whenTransitionEnd);
    };

    el.addEventListener('transitionend', whenTransitionEnd);
  },

  [privateKeys.removeDOM](el) {
    // eslint-disable-line
    const parent = el.parentElement;
    if (!parent) return console.error('no parent', el);
    parent.removeChild(el);
  },

  message(message, options) {
    return this[privateKeys.render]('info', message, options);
  },
  success(message, options) {
    return this[privateKeys.render]('success', message, options);
  },
  alert(message, options) {
    return this[privateKeys.render]('error', message, options);
  },
  hide(buttonEl) {
    this[privateKeys.hide](buttonEl?.parentElement);
  },
  close(el) {
    this[privateKeys.hide](el);
  },
};

// window.customToast = customToast;

// document.addEventListener('DOMContentLoaded', () => {
//   const topleftToast = customToast.setOptions({
//     position: 'bottom|left',
//   });

//   topleftToast
//     .message('Simple message  toast')
//     .message('testing message', { delay: 500 })
//     .success('testing success', { delay: 1000 })
//     .alert('testing alert', { delay: 1500 });
// });

/**
 *
 * @param {Object} param0
 * @property {string} param0.msg
 * @property {number} [param0.timeout]
 * @property {boolean} [param0.manualClose]
 * @property {'info'|'error'|'success'} [param0.type]
 * @property {string} [param0.position]
 * @property {number} [param0.delay]
 */

const show = ({
  msg,
  timeout = 5000,
  manualClose,
  type,
  title,
  position,
  delay,
}) => {
  position = (position || 'bottom-right') //type === 'error' ? 'bottom-center' : 'bottom-right'
    .replace('-', '|');
  if (type == 'success') {
    return customToast.success(msg, {
      duration: timeout,
      position,
      delay,
      manualClose,
    });
  } else if (type == 'info' || !type) {
    return customToast.message(msg, {
      duration: timeout,
      position,
      delay,
      manualClose,
    });
  } else if (type == 'error') {
    return customToast.alert(msg, {
      duration: timeout,
      position,
      delay,
      manualClose,
    });
  }
};

const error = (options) => {
  show({...options, type: 'error'});
};
const info = (options) => {
  show({...options, type: 'info'});
};
const success = (options) => {
  show({...options, type: 'success'});
};
const toastService = {
  info,
  show,
  error,
  success,
  init: function (options) {
    customToast.setOptions(options);
    // document.body.addEventListener('click', (e) => {
    //   if (e.target.classList.contains('customToast--close')) {
    //     customToast.hide(e.target);
    //   }
    // });
  },
  close: (toast) => customToast.close(toast),
};
export default toastService;
